import h from 'hyperscript';
import { assert } from 'cadenza/utils/custom-error';
import { LayerLegendRouteSummary } from 'cadenza/map/legend/layer/extended-info/layer-legend-route-summary/layer-legend-route-summary';
import { LayerLegendIsochroneSummary } from 'cadenza/map/legend/layer/extended-info/layer-legend-route-summary/layer-legend-isochrone-summary';

const TYPE_TO_ELEMENT_MAPPING = {
  ROUTE_SUMMARY: (payload) => new LayerLegendRouteSummary(payload),
  ISOCHRONE_SUMMARY: (payload) => new LayerLegendIsochroneSummary(payload)
};

/**
 * Given an array of extended layer items objects, it creates an HTML elements for each item based
 * on its type, and wrap them in a root element.
 *
 * @param {object[]} extendedInfo - Array of additional info items. Each object must have at least a type property.
 * @param {string} extendedInfo.type - Type of the additional info object, used to map to a web component that will render the info
 * @return {HTMLElement} A root element wrapping all the elements representing the additional info items
 */
export function createExtendedInfoElement (extendedInfo = []) {
  const extendedInfoElements = extendedInfo.map(payload => {
    assert(payload.type, 'Additional info item must have a type field.');
    const componentFactory = TYPE_TO_ELEMENT_MAPPING[payload.type];
    assert(componentFactory, `Could not find a component mapped for additional info type: "${payload.type}"`);
    return componentFactory(payload);
  });

  return extendedInfoElements.length
    ? h('.d-map-layer--extended-info', extendedInfoElements)
    : [];
}
